var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2605_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5C0 28.7173 8.28273 37 18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5Z",
    fill: "#E70013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 26.2162C22.4183 26.2162 26 22.5861 26 18.1081C26 13.6301 22.4183 10 18 10C13.5817 10 10 13.6301 10 18.1081C10 22.5861 13.5817 26.2162 18 26.2162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 24.1895C21.3137 24.1895 24 21.4669 24 18.1084C24 14.7499 21.3137 12.0273 18 12.0273C14.6863 12.0273 12 14.7499 12 18.1084C12 21.4669 14.6863 24.1895 18 24.1895Z",
    fill: "#E70013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6003 22.9729C22.2513 22.9729 24.4003 20.7948 24.4003 18.108C24.4003 15.4212 22.2513 13.2432 19.6003 13.2432C16.9493 13.2432 14.8003 15.4212 14.8003 18.108C14.8003 20.7948 16.9493 22.9729 19.6003 22.9729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.108L22.5125 15.9634L18.4875 21.5781V14.638L22.5125 20.2527L16 18.108Z",
    fill: "#E70013"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2605_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/tn.b6cbec43c8ccd678d58e97461e2fc706.svg";
export { ForwardRef as ReactComponent };